import React from 'react';
import { IPhrasePopupProps } from './types';
import { theme } from '../../../../../../common/styles/theme';
import { Paper } from '../../../../../../common/components/Paper/Paper';
import { alpha, Box, Button, Stack } from '@mui/material';
import { CloseIconLight } from '../../../../../../../icons/CloseIconLight';
import { PhraseDetailsContainerHOC } from '../../PhraseDetailsContainer/hocs/PhraseDetailsContainerHOC';

export const PhrasePopup: React.FC<IPhrasePopupProps> = ({
	isShow,
	onClose,
}) => {
	if (!isShow) return null;

	return <>
		<Paper
			className={'phrase-popup'}
			sx={{
				position: 'absolute',
				zIndex: 200,
				left: 0,
				right: 0,
				top: theme.spacing(5),
				bottom: 0,
				display: 'flex',
				flexDirection: 'column',
				gap: theme.spacing(1),
				boxShadow: theme.shadows[16],
				border: `2px solid ${theme.palette.primary.main}`,
				animation: 'animation_popup .2s forwards',

				'@keyframes animation_popup': {
					'0%': { transform: 'translateY(100px)' }, '100%': { transform: 'translateY(0)' },
				},

				'.phrase-details-column': {
					flex: `1 1 100%`,
					minHeight: 0,
				},
			}}
		>
			<Stack
				flexDirection={'row'}
				justifyContent={'space-between'}
				alignItems={'center'}
				sx={{
					height: theme.spacing(6),
					p: 1,
					pr: 2,
					background: alpha(theme.palette.grey[50], .25),
					borderBottom: `1px solid ${theme.palette.grey[100]}`,
				}}
			>
				<Box
					sx={{
						fontSize: theme.typography.subtitle2,
						fontWeight: 400,
						color: theme.palette.grey[500],
					}}
				>
					Translate & Ask AI
				</Box>
				<Button
					onClick={onClose}
					sx={{
							width: theme.spacing(3),
							height: theme.spacing(3),
							color: theme.palette.grey[400],
							
							'&:hover': {
								color: theme.palette.grey[700],
							},
					
							'.MuiSvgIcon-root': {
								width: theme.spacing(2.5),
								height: theme.spacing(2.5),
							},
						}}
				>
					<CloseIconLight />
				</Button>
			</Stack>

			<PhraseDetailsContainerHOC />
		</Paper>
		<Box
			className={'popup-overlay'}
			onClick={onClose}
			sx={{
				position: 'absolute',
				left: 0,
				right: 0,
				top: 0,
				bottom: theme.spacing(6),
				background: alpha(theme.palette.common.white, .2),
				borderRadius: theme.spacing(.75),
				animation: 'animation_popup_overlay 1s forwards',

				'@keyframes animation_popup_overlay': {
					'0%': { opacity: 0, }, '100%': { opacity: 1, },
				},
			}}
		/>
	</>;

}
